import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import RagDocumentUploadDialog from "./RagDocumentUploadDialog";
import RagDocumentUploadHistory from "./RagDocumentUploadHistory";
import { useApiClient } from "../../../api";
import { usePagination } from "../../../hooks/usePagination";

export default function PersonalisationUpload() {
  const ApiClient = useApiClient();
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [hasOpenChildDialogs, setHasOpenChildDialogs] = useState(false);

  const {
    options: uploads,
    loading,
    page,
    pageInfo,
    handlePageChange,
  } = usePagination(
    ({ first, after }) => ApiClient.rag.getDocumentUploads({ first, after }),
    5,
    {},
  );

  const refetchCurrentPage = () => {
    handlePageChange(null, page);
  };

  useEffect(() => {
    if (page !== 1) return;

    // Pause refresh if any upload dialog is open
    if (uploadDialogOpen || hasOpenChildDialogs) return;

    const interval = setInterval(() => {
      refetchCurrentPage();
    }, 10000);

    return () => clearInterval(interval);
  }, [page, uploadDialogOpen, hasOpenChildDialogs]);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h4">Personalisation</Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<CloudUpload />}
          onClick={() => setUploadDialogOpen(true)}
        >
          Upload Document
        </Button>
      </Box>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          About This Page
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Upload documents that will help personalise your Fruitify experience.
          These documents will be used as references for:
        </Typography>
        <Box component="ul" sx={{ mt: 1, mb: 0, pl: 3 }}>
          <Typography component="li" variant="body2" color="text.secondary">
            Improving marking accuracy and consistency
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            Providing stylistic guidance for feedback
          </Typography>
          <Typography component="li" variant="body2" color="text.secondary">
            Referencing school-specific resources and standards
          </Typography>
        </Box>
      </Paper>

      <RagDocumentUploadHistory
        uploads={uploads}
        loading={loading}
        page={page}
        pageInfo={pageInfo}
        onPageChange={handlePageChange}
        onRefetch={refetchCurrentPage}
        onDialogStateChange={setHasOpenChildDialogs}
      />

      <RagDocumentUploadDialog
        open={uploadDialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        onUploadSuccess={() => {
          setUploadDialogOpen(false);
        }}
      />
    </Box>
  );
}
